/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GrantAcceptanceTemplateListDto } from '../models/PagedResultDto_GrantAcceptanceTemplateListDto';
import type { Wealthlane_AwardService_Dtos_Common_DropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_DropdownDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AddGrantAcceptanceTemplateContentDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AddGrantAcceptanceTemplateContentDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CloneGrantAcceptanceTemplateContentDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CloneGrantAcceptanceTemplateContentDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CreateGrantAcceptanceTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CreateGrantAcceptanceTemplateDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateContentWithTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateContentWithTemplateDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateDataFromTableDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateDataFromTableDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateContentDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateContentDto';
import type { Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateDto } from '../models/Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantAcceptanceTemplateService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantAcceptanceTemplate(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CreateGrantAcceptanceTemplateDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-acceptance-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param statusId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GrantAcceptanceTemplateListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplate(
statusId?: number,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GrantAcceptanceTemplateListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template',
            query: {
                'StatusId': statusId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppGrantAcceptanceTemplateTemplate(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/grant-acceptance-template/template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppGrantAcceptanceTemplateContent(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateGrantAcceptanceTemplateContentDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/grant-acceptance-template/content',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantAcceptanceTemplateContent(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_AddGrantAcceptanceTemplateContentDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-acceptance-template/content',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppGrantAcceptanceTemplateCloneContent(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_CloneGrantAcceptanceTemplateContentDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/grant-acceptance-template/clone-content',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppGrantAcceptanceTemplateDataFromTable(
requestBody?: Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_UpdateDataFromTableDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/grant-acceptance-template/data-from-table',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param templateId 
     * @returns Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateTemplate(
templateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template/template/{templateId}',
            path: {
                'templateId': templateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param templateId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppGrantAcceptanceTemplateTemplate(
templateId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/grant-acceptance-template/template/{templateId}',
            path: {
                'templateId': templateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param contentId 
     * @returns Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateContentWithTemplateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateContent(
contentId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_GrantAcceptanceTemplate_GrantAcceptanceTemplateContentWithTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template/content/{contentId}',
            path: {
                'contentId': contentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param contentId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppGrantAcceptanceTemplateContent(
contentId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/grant-acceptance-template/content/{contentId}',
            path: {
                'contentId': contentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAcceptanceTemplateDropdown(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-acceptance-template/dropdown',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
